export const CLIENT_ID = "dkDfZfImXIdYF3CGJK0ByonOtOd3PVXnuCuq8DLL";
export const CLIENT_SECRET =
  "yIKrAoHsi2mjUL1YHwovktGOGqEgNHHWaAepJRLyUSSN800mXGAbTfF5pP1NP5qq5YrLGaYiMBuPcYt9JMTIonlzJocTS8yiloQUSruivuPXvjLlOulM9H5OJt1kbvgZ";
